export function hasStagingBanner() {
  return !!(
    process.env.NEXT_PUBLIC_STAGING_VERSION &&
    process.env.NEXT_PUBLIC_STAGING_PR_URL
  )
}
